import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from '../../../constant';
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const GrnDetails = () => {
  const tableHeaders = [
    "#",
    "Product",
    "Variant",
    "Gross/Net ",
    " Required",
    "Received",
    "Balance",
    "Unit Price",
    "Remarks",
    "Action"
  ];
const [filteredVariants, setFilteredVariants] = useState([]); // 👈 new state
  const [grnData, setGrnData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
 const [formData, setFormData] = useState({
  id: null,
  sa_veemart_grn_id: localStorage.getItem("sa_veemart_grn_id") || "",
  product_id: "",
  variant_id: "",
  gross_weight: "",
  net_weight: "",
  required_qty: "",
  received_qty: "",
  balance_qty: "",
  unit_price: "",
  remarks: "",
});

const [grnInfo, setGrnInfo] = useState({
  grn_number: "",
  grn_date: "",
  received_by: "",
  
});
const navigate = useNavigate();
const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("name");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
      const storedData = {
      grn_number: localStorage.getItem("grn_number"),
      grn_date: localStorage.getItem("grn_date"),
      received_by: localStorage.getItem("received_by"),
    };
    setGrnInfo(storedData);

    // 🧾 Fetch GRN item details
   
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchGrnData();
      await fetchProductData();
      await fetchVariantData();
    } catch (err) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };


const handleDownloadPDF = () => {
  if (grnData.length === 0) {
    toast.warning("No GRN details to export");
    return;
  }

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  // 🔹 Get username directly from localStorage
const userName = localStorage.getItem("name") || "-";

  // 🔹 Header Title
  doc.setFontSize(16);
  doc.text("Veemart - GRN Details", pageWidth / 2, 15, { align: "center" });

  doc.setFontSize(12);
  doc.text(`GRN Number: ${grnInfo.grn_number || "-"}`, 14, 30);
  doc.text(
    `GRN Date: ${
      grnInfo.grn_date
        ? new Date(grnInfo.grn_date).toLocaleDateString("en-GB")
        : "-"
    }`,
    14,
    38
  );
  doc.text(`Received By: ${userName}`, 14, 46);

  // 🔹 Table columns
  const tableColumn = [
    "S.No",
    "Product",
    "Variant",
    "Gross Wt",
    "Net Wt",
    "Unit Price",
    "Remarks",
  ];

  // 🔹 Table rows
  const tableRows = grnData.map((item, index) => {
    const productName =
      productData.find((p) => p.id === item.product_id)?.product_name || "-";
    const variantName =
      variantData.find((v) => v.id === item.variant_id)?.variant_name || "-";

    return [
      index + 1,
      productName,
      variantName,
      item.gross_weight || "-",
      item.net_weight || "-",
      item.unit_price || "-",
      item.remarks || "-",
    ];
  });

  // 🔹 Draw the table
  autoTable(doc, {
    startY: 55,
    head: [tableColumn],
    body: tableRows,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [41, 128, 185] },
  });

  // 🔹 Footer
  const date = new Date().toLocaleString();
  doc.setFontSize(9);
  doc.text(`Generated by: ${userName}`, 14, doc.internal.pageSize.getHeight() - 16);
  doc.text(`Generated on: ${date}`, 14, doc.internal.pageSize.getHeight() - 10);

  // 🔹 Save the PDF
  doc.save(`Veemart_GRN_${grnInfo.grn_number || "Details"}.pdf`);
};


const handleDownloadExcel = () => {
  if (grnData.length === 0) {
    toast.warning("No GRN details to export");
    return;
  }

  // Prepare Excel rows
  const rows = grnData.map((item, index) => {
    const productName =
      productData.find((p) => p.id === item.product_id)?.product_name || "-";
    const variantName =
      variantData.find((v) => v.id === item.variant_id)?.variant_name || "-";

    return {
      "S.No": index + 1,
      "GRN Number": grnInfo.grn_number || "-",
      "GRN Date": grnInfo.grn_date
        ? new Date(grnInfo.grn_date).toLocaleDateString("en-GB")
        : "-",
      Product: productName,
      Variant: variantName,
      "Gross Weight": item.gross_weight || "-",
      "Net Weight": item.net_weight || "-",
      "Unit Price": item.unit_price || "-",
    };
  });

  // Convert JSON → worksheet → workbook
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "GRN Details");

  // Generate Excel file
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(data, `Veemart_GRN_${grnInfo.grn_number || "Details"}.xlsx`);
};





  const fetchGrnData = async () => {
              const grn_id= localStorage.getItem("sa_veemart_grn_id");

    try {
      const res = await axios.get(`${var_api}sa_veemart_grn_details/getByGrnId/${grn_id}`);
      setGrnData(res.data || []);
    } catch {
      toast.error("Failed to fetch GRN details");
    }
  };

  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setProductData(data);
    } catch {
      toast.error("Failed to fetch products");
    }
  };

  const fetchVariantData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setVariantData(data);
    } catch {
      toast.error("Failed to fetch variants");
    }
  };
// Filter variants when product changes
useEffect(() => {
  if (formData.product_id) {
    const filtered = variantData.filter(v => v.product_id === Number(formData.product_id));
    setFilteredVariants(filtered);
  } else {
    setFilteredVariants([]); // reset if no product chosen
  }
}, [formData.product_id, variantData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const handleAddClick = () => {
  setFormData({
    id: null,
    sa_veemart_grn_id: localStorage.getItem("sa_veemart_grn_id") || "",
    product_id: "",
    variant_id: "",
    gross_weight: "",
    net_weight: "",
    required_qty: "",
    received_qty: "",
    balance_qty: "",
    unit_price: "",
    remarks: "",
  });
  setIsEditMode(false);
  setErrors({});
  setShowModal(true);
};


  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.product_id) newErrors.product_id = "Product is required";
    if (!formData.variant_id) newErrors.variant_id = "Variant is required";
     if (!formData.unit_price) {
    newErrors.unit_price = "Unit price is required";
  } else if (isNaN(formData.unit_price) || Number(formData.unit_price) <= 0) {
    newErrors.unit_price = "Enter a valid positive number";
  }if (!formData.required_qty) {
  newErrors.required_qty = "Required quantity is mandatory";
}
if (!formData.received_qty) {
  newErrors.received_qty = "Received quantity is mandatory";
} else if (
  Number(formData.received_qty) > Number(formData.required_qty)
) {
  newErrors.received_qty = "Received qty cannot exceed required qty";
}


  // ✅ Total Price validation
  
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}sa_veemart_grn_details/update/${formData.id}`, formData);
      } else {
        res = await axios.post(`${var_api}sa_veemart_grn_details/post`, formData);
      }
      toast.success(res?.data?.message || "Record saved successfully!");
      setShowModal(false);
      fetchGrnData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save record");
    } finally {
      setLoading(false);
    }
  };
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);
   const handleDeleteClick = async () => {
    if (!deleteId) return;
  
    try {
      setLoading(true);
      const res = await axios.delete(`${var_api}sa_veemart_grn_details/delete/${deleteId}`);
      toast.success(res?.data?.message || "Record deleted successfully!");
      fetchGrnData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to delete record");
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };
  const filteredData = grnData.filter((item) => {
  const productName =
    productData.find((p) => p.id === item.product_id)?.product_name?.toLowerCase() || "";
  const variantName =
    variantData.find((v) => v.id === item.variant_id)?.variant_name?.toLowerCase() || "";
  const qty = String(item.qty || "").toLowerCase();
  const gross = String(item.gross_weight || "").toLowerCase();
  const net = String(item.net_weight || "").toLowerCase();
    const tax_percent = String(item.tax_percent || "").toLowerCase();
  const unit_price = String(item.unit_price || "").toLowerCase();
  const total_price = String(item.total_price || "").toLowerCase();

  const remarks = String(item.remarks || "").toLowerCase();

  const query = searchQuery.toLowerCase();

  return (
    productName.includes(query) ||
    variantName.includes(query) ||
    qty.includes(query) ||
    gross.includes(query) ||
    net.includes(query) ||
    remarks.includes(query)||
    tax_percent.includes(query)||
        unit_price.includes(query)||
    total_price.includes(query)

  );
});

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
           <Card className="p-3 mb-3 shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">GRN Details</h5>

        {/* 🔙 Back Button */}
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => navigate("/grn")}
        >
          <i className="fas fa-arrow-left me-2"></i> Back to GRN
        </Button>
      </div>

      <Row className="align-items-center g-3 flex-wrap">
        <Col xs="auto">
          <h6>
            <strong>GRN Number:</strong>{" "}
            <span style={{ color: "green" }}>
              {grnInfo.grn_number || "N/A"}
            </span>
          </h6>
        </Col>

        <Col xs="auto">
          <h6>
            <strong>GRN Date:</strong>{" "}
            <span style={{ color: "green" }}>
              {grnInfo.grn_date
                ? new Date(grnInfo.grn_date).toLocaleDateString("en-GB")
                : "-"}
            </span>
          </h6>
        </Col>

       

        <Col xs="auto">
        <h6>
          <strong>Received By:</strong>{" "}
          <span style={{ color: "green" }}>{userName || "N/A"}</span>
        </h6>
      </Col>
      </Row>
    </Card>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                 <Button variant="success" onClick={handleDownloadPDF}>
    <i className="fas fa-file-pdf me-2"></i> Download PDF
  </Button>

  <Button variant="info" onClick={handleDownloadExcel}>
  <i className="fas fa-file-excel me-2"></i> Download Excel
</Button>

                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>
                  Add
                </Button>
              </div>

              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <tr>{tableHeaders.map((h, i) => <th key={i}>{h}</th>)}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => {
                        const productName = productData.find(p => p.id === item.product_id)?.product_name || "-";
                        const variantName = variantData.find(v => v.id === item.variant_id)?.variant_name || "-";
                        return (
                          <tr key={item.id}>
                            <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                            <td>{productName}</td>
                            <td>{variantName}</td>
                            <td>{item.gross_weight}/{item.net_weight}</td>
                            <td>{item.required_qty}</td>
                                                        <td>{item.received_qty}</td>

                            <td>{item.balance_qty}</td>

                            <td>{item.unit_price}</td>
                            <td>{item.remarks}</td>
                            <td className="text-center">
                                 <button
                                className="btn shadow btn-xs sharp"
                                style={{ backgroundColor: "#007bff", color: "white" }}
                                onClick={() => handleEditClick(item)}
                                title="Edit"
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </button>
                                  <button
  className="btn shadow btn-xs sharp"
  style={{ backgroundColor: "#f40c17ff", color: "white" }}
  onClick={() => {
    setDeleteId(item.id);
    setShowDeleteModal(true);
  }}
  title="Delete"
>
  <i className="fas fa-trash"></i>
</button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit GRN Detail" : "Add GRN Detail"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
        <Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>
      Product <span className="text-danger">*</span>
    </Form.Label>
    <Select
      name="product_id"
      value={
        productData
          .filter((p) => p.id === Number(formData.product_id))
          .map((p) => ({ value: p.id, label: p.product_name }))[0] || null
      }
      onChange={(selectedOption) => {
        setFormData((prev) => ({
          ...prev,
          product_id: selectedOption ? selectedOption.value : "",
          variant_id: "", // reset variant when product changes
        }));
        // ✅ Clear product error instantly
        setErrors((prev) => ({ ...prev, product_id: "" }));
      }}
      options={productData.map((p) => ({
        value: p.id,
        label: p.product_name,
      }))}
      placeholder="Select Product"
      isClearable
    />
    {errors.product_id && (
      <div className="text-danger small">{errors.product_id}</div>
    )}
  </Form.Group>
</Col>

       
    <Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>
      Variant <span className="text-danger">*</span>
    </Form.Label>
    <Select
      name="variant_id"
      value={
        filteredVariants
          .filter((v) => v.id === Number(formData.variant_id))
          .map((v) => ({ value: v.id, label: v.variant_name }))[0] || null
      }
      onChange={(selectedOption) => {
        setFormData((prev) => ({
          ...prev,
          variant_id: selectedOption ? selectedOption.value : "",
        }));
        // ✅ Clear variant error instantly
        setErrors((prev) => ({ ...prev, variant_id: "" }));
      }}
      options={filteredVariants.map((v) => ({
        value: v.id,
        label: v.variant_name,
      }))}
      placeholder={
        formData.product_id ? "Select Variant" : "Select Product First"
      }
      isClearable
      isDisabled={!formData.product_id}
    />
    {errors.variant_id && (
      <div className="text-danger small">{errors.variant_id}</div>
    )}
  </Form.Group>
</Col>


                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Gross Weight</Form.Label>
                    <Form.Control name="gross_weight" value={formData.gross_weight} onChange={handleInputChange} placeholder="Enter gross weight" />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Net Weight</Form.Label>
                    <Form.Control name="net_weight" value={formData.net_weight} onChange={handleInputChange} placeholder="Enter net weight" />
                  </Form.Group>
                </Col>
<Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>
      Required Qty <span className="text-danger">*</span>
    </Form.Label>
    <Form.Control
      type="number"
      min="1"
      name="required_qty"
      value={formData.required_qty}
      onChange={(e) => {
        const value = e.target.value;
        setFormData((prev) => ({
          ...prev,
          required_qty: value,
          // auto-calc balance if received entered
          balance_qty:
            prev.received_qty && value
              ? value - prev.received_qty
              : prev.balance_qty,
        }));
        setErrors((prev) => ({ ...prev, required_qty: "" }));
      }}
      placeholder="Enter required quantity"
    />
    {errors.required_qty && (
      <div className="text-danger small">{errors.required_qty}</div>
    )}
  </Form.Group>
</Col>

<Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>
      Received Qty <span className="text-danger">*</span>
    </Form.Label>
    <Form.Control
      type="number"
      min="0"
      name="received_qty"
      value={formData.received_qty}
      onChange={(e) => {
        const value = e.target.value;
        setFormData((prev) => ({
          ...prev,
          received_qty: value,
          balance_qty:
            prev.required_qty && value
              ? prev.required_qty - value
              : prev.balance_qty,
        }));
        setErrors((prev) => ({ ...prev, received_qty: "" }));
      }}
      placeholder="Enter received quantity"
    />
    {errors.received_qty && (
      <div className="text-danger small">{errors.received_qty}</div>
    )}
  </Form.Group>
</Col>

<Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>Balance Qty</Form.Label>
    <Form.Control
      type="number"
      name="balance_qty"
      value={formData.balance_qty}
      readOnly
      placeholder="Auto-calculated"
    />
  </Form.Group>
</Col>

                       <Col md={4}>
               <Form.Group className="mb-3">
                 <Form.Label>Unit Price <span className="text-danger">*</span></Form.Label>
                 <Form.Control
                   type="number"
                   min="1"
                  name="unit_price"
                   value={formData.unit_price}
                   onChange={(e) => {
                     const value = e.target.value;
                     setFormData((prev) => ({ ...prev, unit_price: value }));
                     setErrors((prev) => ({ ...prev, unit_price: "" }));
                   }}
                   placeholder="Enter unit price"
                 />
                 {errors.unit_price && (
                   <div className="text-danger small">{errors.unit_price}</div>
                 )}
               </Form.Group>
             </Col>

                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control name="remarks" value={formData.remarks} onChange={handleInputChange} placeholder="Enter remarks" />
                  </Form.Group>
                </Col>
              </Row>

             <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Creating...
                        </>
                      ) : (
                        "Create"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      type="reset"
                      disabled={loading}
                      onClick={() =>
                        setFormData({
                           id: null,
      sa_veemart_grn_id: localStorage.getItem("sa_veemart_grn_id") || "",
      product_id: "",
      variant_id: "",
      gross_weight: "",
      net_weight: "",
      unit_price: "",
      remarks: "",
                        })
                      }
                    >
                      Reset
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Updating...
                        </>
                      ) : (
                        "Update"
                      )}
                    </Button>
                    <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>
               <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to delete this record? This action cannot be undone.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="warning" onClick={handleDeleteClick} disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Deleting...
                </>
              ) : (
                "Delete"
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </Card>
      <ToastContainer />
    </>
  );
};

export default GrnDetails;
